import React from 'react';
import { Form, Checkbox, Button, Typography } from 'antd';

const { Title } = Typography;
const samplePDF = "https://firebasestorage.googleapis.com/v0/b/operataxis.firebasestorage.app/o/DriverRegistration%2FDrug%20and%20Alchol%20Policy.pdf?alt=media&token=ab1f17e2-5bef-411c-9481-4ac14f99009c"

const Step13 = ({ form, next, prev }) => {
  const handleSubmit = () => {
    form
      .validateFields()
      .then(values => {
        next(); 
      })
      .catch(errorInfo => {
        console.log('Validation Failed:', errorInfo);
      });
  };

  return (
    <Form form={form} layout="vertical" style={{ maxWidth: 800, margin: '0 auto' }}>
      <Title level={2}>Drug and Alchol Policy</Title>
      <div style={{ height: "500px", border: "1px solid #ccc", marginBottom: "20px" }}>
        <iframe
          src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(samplePDF)}`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="PDF Viewer"
        />
      </div>

      <Form.Item
        name="safetyTraining"
        valuePropName="checked"
        rules={[{ required: true, message: 'Please confirm you have read this ' }]}
      >
        <Checkbox onChange={(e) => {
      form.setFieldsValue({
        safetyTraining: e.target.checked ? "agree" : undefined,
      });
    }}>I have read and understood the Drug and Alchol Policy.</Checkbox>
      </Form.Item>

      <Form.Item style={{ textAlign: 'center' }}>
        <Button onClick={prev} style={{ marginRight: 8 }}>
          Back
        </Button>
        <Button type="primary" onClick={handleSubmit}>
          Next
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Step13; 